import useImageSize from "../../../../../hooks/global/useImageSize";
import { useBlogCoachCardContext } from "./BlogCoachCardProvider";
import { Avatar } from "@mui/material";

export const BlogCoachCardImage = () => {
  const { state } = useBlogCoachCardContext();
  const [avatarImg] = useImageSize({
    imageUrl: state.coach.avatarUrl,
    size: 300,
    isProfile: true,
    originalFormat: true,
  });

  return (
    <Avatar
      src={avatarImg}
      sx={{
        width: "2.5rem",
        height: "2.5rem",
      }}
    >
      {state.coach.name[0]}
    </Avatar>
  );
};
